export default function QuizHeader({
    score,
    currentQuestion,
    totalQuestions,
    title,
    schoolTrack,
    subject,
    text,
}) {
    return (
        <div className="quiz-header">
            <div className="quiz-topbar">
                <span className="quiz-label">{text.quiz}</span>
                <span className="quiz-score">{text.score}: {score}</span>
            </div>
            <h1>{title}</h1>
            {(schoolTrack || subject) && (
                <div className="quiz-header-classification">
                    {schoolTrack && (
                        <p>
                            <strong>{text.schoolClassroom}:</strong> {schoolTrack}
                        </p>
                    )}
                    {subject && (
                        <p>
                            <strong>{text.subjectLabel}:</strong> {subject}
                        </p>
                    )}
                </div>
            )}
            <div className="quiz-progress">
                <span>
                    {text.question} {currentQuestion + 1} / {totalQuestions}
                </span>
            </div>
        </div>
    );
}